// pages/Config/WifiPlanCreatePage.jsx
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import PageContainer from '../../../layouts/PageContainer';
import PageHeader from '../../../components/Nav/PageHeader';
import WifiPlanForm from '../../../components/Config/WifiPlanForm';
import ajaxConfig from '../../../util/remote/ajaxConfig';
import { useConfig } from '../../../DataStore/ConfigContext';

export default function WifiPlanCreatePage() {
  const navigate = useNavigate();
  const {getWifiPlans} = useConfig();
  const { state } = useLocation(); // optional: initial from duplication
  const initialValues = state?.initial;

  const savePlan = async (payload) => {
    const server_response = await ajaxConfig.createWifiPlan(payload);
    if (server_response.status === "OK") {
      getWifiPlans(true);
      navigate('/settings/plans', { state: { flash: { type: 'success', msg: server_response.message || 'Plan created.' } } });
      return { ok: true };
    }
    return { ok: false, message: server_response.message || 'Failed to create plan.' };
  };

  return (
    <PageContainer>
      <PageHeader
        title="New WiFi Plan"
        breadcrumb={<>
        <li className="breadcrumb-item"><Link to="/settings">Settings</Link></li>
        <li className="breadcrumb-item"><Link to="/settings/plans">WiFi Plans</Link></li>
        <li className="breadcrumb-item active">New</li>
        </>}
      />
      {/* Top summary row */} <div className="row mb-3"> <div className="col-12"> <div className="alert alert-info mb-0"> Create plans your users can purchase in the captive portal. Plans can be <strong>Time-based</strong>, <strong>Data-based</strong>, or <strong>Hybrid</strong> (whichever limit is reached first ends the session). </div> </div> </div>
        <WifiPlanForm
          initialValues={initialValues}
          onSubmit={async (payload) => await savePlan(payload)}
        />
    </PageContainer>
  );
}
